import React, {
  ReactNode,
} from 'react';

import { Box } from '@waglabs/box-next';
import { Flex } from '@waglabs/flex-next';

import type { webApp } from '../../../../../../../types/webapp';

type Props = webApp.StyledSystemProps & {
  children?: ReactNode;
};

export const SocialSigninOptions = ({
  children,
  ...rest
}: Props) => (
  <Box
    {...rest}
  >
    <Flex
      flexDirection={['column', null, 'row']}
    >
      {children}
    </Flex>
  </Box>
);
